import { Price } from "./Price";
import { twMerge } from "tailwind-merge";
import { Button } from "./ui/Button";
import { useCheckoutContext } from "../contexts/checkout.context";
import { useStoreItemContext } from "../contexts/store-item.context";
import type { PriceType } from "../types";
import { useCheckBalance } from "../hooks/useCheckBalance";
import { Funds } from "~/features/bank/components/Funds";
import { useBankGates } from "~/features/bank/hooks/useBankGates";

interface PaymentMethodProps {
    price: PriceType;
}

export const PaymentMethod = ({ price }: PaymentMethodProps) => {
    const { selectedPrice, setSelectedPrice } = useCheckoutContext()
    const enoughBalance = useCheckBalance(price)
    const isSelected = price === selectedPrice

    return <button
        className={twMerge(
            "flex flex-row items-center justify-center gap-1 grow border border-white/10 rounded hover:bg-white/10 select-none p-3",
            isSelected && 'outline outline-violet-500',
            !enoughBalance && 'hover:bg-transparent'
        )}
        onClick={() => enoughBalance && setSelectedPrice(isSelected ? null : price)}
    >
        <Price price={price} showDepositIcon={!enoughBalance} disabled={!enoughBalance} />
    </button>
}

export const PaymentSelect = () => {
    const { item } = useStoreItemContext()
    const { price_set } = item
    const { selectedPrice, setStep } = useCheckoutContext()
    const { spendBlocked } = useBankGates()

    if (!(price_set || []).length) return null

    return <div className="flex flex-col gap-4">
        <div className="text-2xs uppercase text-center">Your account balance will be used</div>
        <div className="flex flex-row flex-wrap gap-4">
            {price_set?.map(p => <PaymentMethod key={p.currency} price={p} />)}
        </div>
        {/* Priced against `usdc` by useCheckBalance, so say which balance before they commit. */}
        <Funds.Note />
        {spendBlocked && <div className="text-2xs uppercase text-center text-amber-400/80">{spendBlocked}</div>}
        <Button disabled={!selectedPrice || !!spendBlocked} onClick={() => setStep(s => s + 1)}>CHECKOUT</Button>
    </div>
}